/**
 * Outline chat-example chips, matching Groups overview follow-ups.
 */
import { ChatIcon } from '@phosphor-icons/react';
import { twMerge } from 'tailwind-merge';
import Button from 'src/components/ui/Button';
import type { DashboardChatExample } from '../utils/dashboardChat';

interface DashboardChatExampleButtonsProps {
  examples: DashboardChatExample[];
  onSelect: (example: DashboardChatExample) => void;
  className?: string;
}

export default function DashboardChatExampleButtons({
  examples,
  onSelect,
  className
}: DashboardChatExampleButtonsProps) {
  return (
    <div className={twMerge('flex flex-wrap gap-2', className)}>
      {examples.map((example) => (
        <Button
          key={example.id}
          variant="outline"
          size="sm"
          text={example.label}
          icon={ChatIcon}
          onClick={() => onSelect(example)}
        />
      ))}
    </div>
  );
}
